import { AdPlacement } from "@/components/ads/AdPlacement";
import { CountdownTimer } from "../components/CountdownTimer";
import { PresetGrid } from "../components/PresetGrid";
import { TimerBreadcrumb } from "../components/TimerBreadcrumb";
import { TimerExplainer } from "../components/TimerExplainer";
import type { TimerPreset } from "../lib/presets";

/** Generic page for any preset countdown timer, rendered from its `TimerPreset`. */
export function PresetTimerPage({ preset }: { preset: TimerPreset }) {
  return (
    <div className="pct-page relative min-h-screen">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-96 pct-glow" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <TimerBreadcrumb current={preset.navName()} />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {preset.h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {preset.intro()}
          </p>
        </header>

        {/* key forces a fresh timer when navigating between presets via SPA nav. */}
        <CountdownTimer key={preset.slug} initialSeconds={preset.seconds} />

        <TimerExplainer
          howTo={preset.howTo()}
          faqs={preset.faqs.map((f) => ({ q: f.q(), a: f.a() }))}
          uses={preset.uses?.map((u) => u())}
        />

        <AdPlacement className="mt-10" />
        <PresetGrid currentSlug={preset.slug} />
      </div>
    </div>
  );
}
